<app-top-menu></app-top-menu>
<div class="page-wrapper">
  <router-outlet></router-outlet>
</div>
<div class="fb-customerchat" page_id="699362933511679" theme_color="#0A7CFF"></div>
<app-footer></app-footer>